/**
 * TODO: Implementation in future step.
 */
export const CHATBOT_FEATURE_KEY = 'talkToYourDataChatbot';
export const TALK_TO_YOUR_DATA_HISTORY_STORAGE_KEY = 'talk-to-your-data-history';
export const TALK_TO_YOUR_DATA_SAVED_CONVERSATIONS_STORAGE_KEY = 'talk-to-your-data-saved-conversations';
export const TALK_TO_YOUR_DATA_HISTORY_MAX_ITEMS = 30;
export const TALK_TO_YOUR_DATA_API_BASE_PATH = '/t2yd/api/v1/';
export const TALK_TO_YOUR_DATA_CHAT_API_PATH = `${TALK_TO_YOUR_DATA_API_BASE_PATH}chat`;
export const TALK_TO_YOUR_DATA_CONVERSATION_API_PATH = `${TALK_TO_YOUR_DATA_API_BASE_PATH}conversations/{conversation_id}`;

export const getTalkToYourDataApiUrl = (apimBaseUrl: string, apiPath: string): string => {
  const gatewayOrigin = new URL(apimBaseUrl).origin;
  return `${gatewayOrigin}${apiPath}`;
};

export const getTalkToYourDataApiBaseUrl = (apimBaseUrl: string): string =>
  getTalkToYourDataApiUrl(apimBaseUrl, TALK_TO_YOUR_DATA_API_BASE_PATH);
